import React, { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { ComponentSizes, OptionKeyValue } from '@myriadgenetics/mgh-types';
import { getDisplayKey, isOptionSelected, convertToTestId } from '../helpers';
import SelectionOption from '../../../../elements/selection-option';
import { Text2 } from '../../../../elements/typography';
import CheckboxGroup from '../../checkbox-group';
import { ReactComponent as PatientAvatarIcon } from '../../../../assets/icons/patient-avatar.svg';

import './index.scss';
const baseClass = 'option-select';
interface Props {
  isSingleSelect?: boolean;
  labelKey: string;
  onOptionSelected: (selectedOption: OptionKeyValue) => void;
  selectedOptions: OptionKeyValue[] | string;
  selectionOptions: OptionKeyValue[];
  isChatbotStyle?: boolean;
  compDef: any;
  optionSizes?: ComponentSizes;
}

function SelectionList({ isSingleSelect, labelKey, onOptionSelected, selectedOptions, selectionOptions, isChatbotStyle, compDef, optionSizes }: Props) {
  const { t } = useTranslation();

  const optionsToShow = useMemo(() => {
    const hasMadeSelection = selectedOptions?.length > 0;
    if (isChatbotStyle && hasMadeSelection) {
      return selectionOptions.filter((option) => option === selectedOptions[0]);
    }
    return selectionOptions;
  }, [selectedOptions, selectionOptions, isChatbotStyle]);

  return (
    <React.Fragment>
      <fieldset name="optionSelect" className={`${baseClass}__container`}>
        {labelKey && <Text2 tag="legend">{t(labelKey)}</Text2>}
        {isSingleSelect ? (
          <div className={`${baseClass}__options`}>
            {optionsToShow.map((option) => (
              <SelectionOption
                className={`${baseClass}__option`}
                isPrimary={option.isPrimary}
                openLink={option.openLink}
                key={option.optionKey}
                onClick={() => onOptionSelected(option)}
                selected={isOptionSelected(option, selectedOptions)}
                dataTestId={convertToTestId(getDisplayKey(option))}
                size={optionSizes ?? compDef.data.optionSize}
              >
                <Trans i18nKey={getDisplayKey(option, isOptionSelected(option, selectedOptions))} />
              </SelectionOption>
            ))}
          </div>
        ) : (
          <CheckboxGroup
            compDef={compDef}
            className="checkbox__group"
            optionsToShow={optionsToShow}
            selectedOptions={selectedOptions as OptionKeyValue[]}
            onOptionSelected={onOptionSelected}
          />
        )}
        {isChatbotStyle && selectedOptions?.length > 0 && (
          <div className="avatar-container">
            <PatientAvatarIcon />
          </div>
        )}
      </fieldset>
    </React.Fragment>
  );
}

export default SelectionList;
